import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'

import ApiService from './services/api.service'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'
// Tell Vue to use the plugin

Vue.config.productionTip = false
ApiService.init(process.env.VUE_APP_API_URL)

new Vue({
  router,
  store,
  vuetify,
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  render: h => h(App)
}).$mount('#app')

Vue.use(VueSweetalert2)
